export const UPDATE_APP_LOADING_STATUS = 'UPDATE_APP_LOADING_STATUS'
